import { FunctionComponent } from 'react';
import { ITuple3 } from '../component-data-structure';

interface IParentProps {
	occlusion?: boolean;
	rotation?: ITuple3;
	position?: ITuple3;
    occlusionPolygonOffset?: number;
	occlusionPlanePosition?: ITuple3;
	shadowPlanePosition?: ITuple3;
    shadowPlanePolygonOffset?: number;
	opacity?: number;
}

const ShadowPlane: FunctionComponent<IParentProps> = ({ occlusion = false, rotation, position, opacity = 0.15, shadowPlanePosition, occlusionPlanePosition, occlusionPolygonOffset = 20, shadowPlanePolygonOffset = -10 }) => {
	return (
		<group name={'shadow-plane-group'} rotation={rotation} position={position}>
			<mesh receiveShadow position={shadowPlanePosition}>
				<planeGeometry args={[50, 50]} />
				{/* <meshBasicMaterial color={new Color('red')} /> */}
				<shadowMaterial
					opacity={opacity}
					depthWrite={false}
					polygonOffset
					polygonOffsetFactor={shadowPlanePolygonOffset} // positive value pushes polygon further away
					polygonOffsetUnits={Math.abs(shadowPlanePolygonOffset)}
				/>
			</mesh>
			{occlusion && <mesh position={occlusionPlanePosition}>
				<planeGeometry args={[50, 50, 1, 1]} />
				<meshBasicMaterial
					colorWrite={false}
					depthWrite={true}
					polygonOffset
					polygonOffsetFactor={occlusionPolygonOffset} // positive value pushes polygon further away
					polygonOffsetUnits={Math.abs(occlusionPolygonOffset)}
				/>
			</mesh>}
		</group>
	);
};

export default ShadowPlane;
